import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function queueRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value?.id ? null : { queueRequired: { value: true } };
  };
}
